module.exports = __webpack_public_path__ + "img/banner-opleidingen.1c65d653.png";